import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
app.initializers.add('val-ui-compact-post-ids', () => {
  override(Discussion.prototype, 'postIds', function (original) {
    const compact = this.attribute('valPostIds');
    if (!Array.isArray(compact)) {
      return original();
    }

    /*
     * valPostIds constitue la liste compacte chargée avec la discussion.
     * Elle ne doit cependant pas figer postIds() : après la publication
     * d'une réponse, le nouveau Post est déjà dans le store Flarum avant
     * que le PostStream appelle update().
     *
     * On conserve donc toute la liste compacte, puis on lui ajoute les
     * éventuels posts de cette discussion connus plus récemment du store.
     */
    const ids = compact.map(String);
    const seen = new Set(ids);

    /*
     * Si Flarum possède malgré tout une relation native partielle,
     * on la fusionne également.
     */
    const nativeIds = original();
    if (Array.isArray(nativeIds)) {
      nativeIds.forEach(id => {
        id = String(id);
        if (!seen.has(id)) {
          seen.add(id);
          ids.push(id);
        }
      });
    }

    /*
     * Les nouveaux posts créés depuis le chargement de la discussion
     * sont présents ici même si valPostIds est encore l'ancien tableau.
     */
    const discussionId = String(this.id());
    const knownPosts = app.store.all('posts').filter(post => {
      if (!post || typeof post.discussion !== 'function') {
        return false;
      }
      const discussion = post.discussion();
      return discussion && typeof discussion.id === 'function' && String(discussion.id()) === discussionId;
    }).sort((a, b) => {
      const an = typeof a.number === 'function' ? Number(a.number()) : 0;
      const bn = typeof b.number === 'function' ? Number(b.number()) : 0;
      return an - bn;
    });
    knownPosts.forEach(post => {
      const id = String(post.id());
      if (!seen.has(id)) {
        seen.add(id);
        ids.push(id);
      }
    });
    return ids;
  });
});